import React from 'react';
import { trLower } from '../../../utils/trText';

const DynamicMarker = ({ 
  firma,
  durum,
  durum_name,
  segment,
  size = 16,
  onClick,
  isSelected = false 
}) => {
  const getFirmaConfig = (firmaId) => {
    const configs = {
      0: { 
        color: '#1a237e', // ATM Point - Lacivert 
        name: 'ATM Point',
        shape: 'circle'
      },
      1: { 
        color: '#4CAF50', // ATM City - Yeşil
        name: 'ATM City',
        shape: 'circle'
      },
      2: { 
        color: '#1976d2', // ATM İstanbul - Mavi 
        name: 'ATM İstanbul',
        shape: 'circle'
      },
      9: { 
        color: '#00b8d4', // ATM Kiralama - Açık Mavi
        name: 'ATM Kiralama',
        shape: 'circle'
      },
      16: { 
        color: '#8d6e63', // Neta - Bej/kahve 
        name: 'Neta',
        shape: 'circle'
      }
    };
    return configs[firmaId] || {
      color: '#9e9e9e', 
      name: 'Bilinmeyen Firma',
      shape: 'circle'
    };
  };

  const getDurumBorderColor = (durumName) => {
    if (!durumName) return '#261717';
    
    const statusText = trLower(typeof durumName === 'object' ? durumName.durum_name || '' : durumName || '');
    if (statusText.includes('aday') || (statusText.includes('pasif') && statusText.includes('aday'))) {
      return '#8c8c8c'; 
    } else if (statusText.includes('pasif')) {
      return '#f5222d'; 
    } else if (statusText.includes('aktif')) {
      return '#52c41a';
    }
    
    return '#261717';
  };

  const firmaConfig = getFirmaConfig(firma);
  const borderColor = getDurumBorderColor(durum_name);
  const borderWidth = 6
  const actualSize = isSelected ? size * 1 : size;

  const renderShape = () => {
    const center = actualSize / 2;
    const radius = center - borderWidth;
    
    return (
      <>
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill={firmaConfig.color}
          stroke={borderColor}
          strokeWidth={borderWidth}
          opacity={durum === 2 ? 0.6 : 1}
        />
        {isSelected && (
          <path
            d={generateStarPath(center, center, radius * 0.6, radius * 0.3, 5)}
            fill="#fff"
            stroke="#fff"
            strokeWidth="0.5"
          />
        )}
      </>
    );
  };

  const generateStarPath = (cx, cy, outerRadius, innerRadius, points) => {
    let path = '';
    const angle = Math.PI / points;
    
    for (let i = 0; i < 2 * points; i++) {
      const radius = i % 2 === 0 ? outerRadius : innerRadius;
      const x = cx + radius * Math.cos(i * angle - Math.PI / 2);
      const y = cy + radius * Math.sin(i * angle - Math.PI / 2);
      path += (i === 0 ? 'M' : 'L') + x + ' ' + y;
    }
    return path + 'Z';
  };

  return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        onClick={onClick}
        title={`${firmaConfig.name} - Durum: ${durum} - Segment: ${segment}`}
        width={actualSize}
        height={actualSize}
        viewBox={`0 0 ${actualSize+4} ${actualSize+4}`}
        style={{
          filter: isSelected ? 'drop-shadow(0 0 2px rgba(0,0,0,0.8))' : 'drop-shadow(0 2px 2px rgba(0,0,0,0.4))', 
          transition: 'all 0.3s ease',
          cursor: 'pointer'
        }}
      >
        {renderShape()}
        {isSelected && (
          <circle
            cx={actualSize / 2}
            cy={actualSize / 2}
            r={actualSize / 4 - 1}
            fill="none"
            stroke="#fff"
            strokeWidth="3"
            strokeDasharray="4,2"
            opacity="0.8"
          />
        )}
      </svg>
  );
};

export default DynamicMarker;